import { TYPES } from "./default_client.type";

const initState = {
  defaultClientAll: null,
  defaultClientOpenAdd: false,
  defaultClientOpenEdit: false,
  defaultClientSelected: null,
  defaultClientSearch: "",
  //
  defaultClientInfo: null,
  defaultClientType: "email",
  //
  defaultClientDetail: null,
  //
  defaultClientStep: 0,
};

const defaultClientReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DEFAULT_CLIENT_STEP:
      return {
        ...state,
        defaultClientStep: payload,
      };

    case TYPES.SET_DEFAULT_CLIENT_DETAIL:
      return {
        ...state,
        defaultClientDetail: payload,
      };

    case TYPES.SET_DEFAULT_CLIENT_TYPE:
      return {
        ...state,
        defaultClientType: payload,
      };

    case TYPES.SET_DEFAULT_CLIENT_INFO:
      return {
        ...state,
        defaultClientInfo: payload,
      };

    case TYPES.SET_DEFAULT_CLIENT_ALL:
      return {
        ...state,
        defaultClientAll: payload,
      };

    case TYPES.SET_DEFAULT_CLIENT_OPEN_ADD:
      return {
        ...state,
        defaultClientOpenAdd: payload,
      };

    case TYPES.SET_DEFAULT_CLIENT_OPEN_EDIT:
      return {
        ...state,
        defaultClientOpenEdit: payload,
      };

    case TYPES.SET_DEFAULT_CLIENT_SELECTED:
      return {
        ...state,
        defaultClientSelected: payload,
      };

    case TYPES.SET_DEFAULT_CLIENT_SEARCH:
      return {
        ...state,
        defaultClientSearch: payload,
      };

    default:
      return state;
  }
};

export default defaultClientReducer;
